/* eslint-disable no-plusplus */
import DOMReady from '../utils/DOMReady'

// Include css for webpack (for development only)
const css = require('../../css/blocks/people-slider.scss') // eslint-disable-line no-unused-vars

class PeopleSlider {
  constructor(el) {
    this.container = el
    this.root = document.documentElement
    this.slidesWrapper = this.container.querySelector('.people-slider__wrapper')
    this.slides = this.container.querySelectorAll('.people-slider__slide')
    this.totalSlides = this.slides.length
    this.directionBtns = this.container.querySelectorAll('[data-direction]')
    this.translateDistance = 0
    this.traveledDistance = 0
    this.activeSlide = null
    this.isGrabbed = false
    this.start = 0
    this.change = 0
    this.touch = 0

    this.init()
  }

  getSlidesArray() {
    this.slides = this.container.querySelectorAll('.people-slider__slide')
    return [...this.container.querySelectorAll('.people-slider__slide')]
  }

  toggleSlideActiveClass(selectedSlide) {
    const slidesArray = this.getSlidesArray()
    const slideIndex = slidesArray.indexOf(selectedSlide)
    slidesArray.forEach((slide, i) =>
      i === slideIndex
        ? slide.classList.toggle('active', true)
        : slide.classList.toggle('active', false),
    )
  }

  addNewSideSlides(direction) {
    const slidesArray = this.getSlidesArray()
    if (direction === 'next') {
      const newSlide = slidesArray[2].cloneNode(true)
      this.slidesWrapper.appendChild(newSlide)
    } else {
      const newSlide = slidesArray[this.totalSlides - 1].cloneNode(true)
      this.slidesWrapper.insertBefore(newSlide, this.slidesWrapper.children[0])
    }
  }

  removeExcessSlide(direction) {
    if (direction === 'next') {
      this.slidesWrapper.removeChild(this.slidesWrapper.firstElementChild)
    } else {
      this.slidesWrapper.removeChild(this.slidesWrapper.lastElementChild)
    }
  }

  handleSlideChange(direction) {
    let newActiveSlide
    if (direction === 'next') {
      newActiveSlide = this.activeSlide.nextElementSibling
      this.traveledDistance -= this.translateDistance
      this.root.style.setProperty('--transformOrigin', 'right')
    } else {
      newActiveSlide = this.activeSlide.previousElementSibling
      this.traveledDistance += this.translateDistance
      this.root.style.setProperty('--transformOrigin', 'left')
    }
    this.root.style.setProperty('--translateDistance', `${this.traveledDistance}px`)
    this.addNewSideSlides(direction)
    this.toggleSlideActiveClass(newActiveSlide)
    this.traveledDistance = 0
    this.removeExcessSlide(direction)
    this.activeSlide = newActiveSlide
  }

  init() {
    const wrapperWidth = this.slidesWrapper.offsetWidth
    this.translateDistance = wrapperWidth * 0.045 + wrapperWidth * 0.005
    const slidesArray = this.getSlidesArray()
    const half = Math.ceil(this.totalSlides / 2)
    const leftNewSlide = slidesArray[this.totalSlides - 1].cloneNode(true)
    const rightNewSlide = slidesArray[0].cloneNode(true)
    this.slidesWrapper.appendChild(rightNewSlide)
    this.slidesWrapper.insertBefore(leftNewSlide, this.slidesWrapper.children[0])
    this.activeSlide = this.getSlidesArray()[half]
    this.toggleSlideActiveClass(this.activeSlide)

    this.directionBtns.forEach(btn => {
      btn.addEventListener('click', e => this.handleSlideChange(e.target.dataset.direction))
    })
    this.slidesWrapper.addEventListener('pointerdown', e => {
      this.isGrabbed = true
      this.start = e.clientX
    })
    this.slidesWrapper.addEventListener('pointermove', e => {
      e.preventDefault()
      if (this.isGrabbed) {
        this.touch = e.clientX
        this.change = this.start - this.touch
      }
    })
    this.slidesWrapper.addEventListener('pointerup', e => {
      const clickedSlide = e.target.closest('.people-slider__slide')
      if (clickedSlide) {
        if (clickedSlide.classList.contains('active')) {
          if (this.change > 0) {
            this.handleSlideChange('next')
          } else if (this.change < 0) {
            this.handleSlideChange('prev')
          }
        } else {
          const currentSlides = this.getSlidesArray()
          const clickedSlideIndex = currentSlides.indexOf(clickedSlide)
          const currentSlideIndex = currentSlides.indexOf(this.activeSlide)
          const direction = clickedSlideIndex > currentSlideIndex ? 'next' : 'prev'
          let counter = Math.abs(currentSlideIndex - clickedSlideIndex)

          while (counter > 0) {
            this.handleSlideChange(direction)
            counter--
          }
        }
      }
      this.isGrabbed = false
    })
  }
}

DOMReady(() => {
  const wrapperEl = document.querySelectorAll('.people-slider')
  Array.from(wrapperEl).forEach(el => {
    // eslint-disable-next-line no-new
    new PeopleSlider(el)
  })
})
